<template>
    <ui-modal-full-size :large="true" ref="modal">
        <template v-slot:header>
            <div class="flex m-4">
                <div
                    class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                    <i class="h-6 w-6 mt-2 ml-2 text-blue-500 fas fa-envelope"></i>
                </div>
                <h3
                    class="flex-grow text-lg leading-6 font-medium text-gray-900 mx-4 mt-2"
                    id="modal-headline"
                >Inbound Email</h3>
                <button @click.prevent="close"
                        class="mb-2 p-2 border border-gray-300 bg-white hover:bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                         class="text-gray-400 h-5 w-5">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </div>
        </template>
        <div class="mx-4 overflow-y-scroll mb-8">
            <ui-tabs active="html" class="mx-4" :tabs="tabs" #default="{ isActive }" nav-class="space-x-4 mb-2">
                <div v-if="isActive('html')" v-html="email.htmlBody" class="overflow-x-scroll w-full"></div>
                <div v-else-if="isActive('text')" class="overflow-x-scroll w-full">
                    <div class="text-blue-600 font-semibold">Extracted Stripped Text Body:</div>
                    <div v-if="email.strippedTextReply" v-text="email.strippedTextReply"
                         class="text-gray-400 font-mono text-gray-500 whitespace-pre-wrap"></div>
                    <div v-else class="text-gray-300">No stripped text could be extracted</div>
                    <div class="text-blue-600 font-semibold mt-4 whitespace-pre-wrap">Email Plain Text:</div>
                    <div v-text="email.textBody" class="text-gray-400 font-mono text-gray-500"></div>
                </div>
                <div v-else-if="isActive('data')" class="overflow-x-scroll w-full">
                    <div>
                        <span class="text-blue-600 font-semibold">Message Id:</span>
                        <span v-text="email.messageID"></span>
                    </div>
                    <div>
                        <span class="text-blue-600 font-semibold">Message stream:</span>
                        <span v-text="email.messageStream"></span>
                    </div>
                    <div>
                        <span class="text-blue-600 font-semibold">From:</span>
                        <span v-text="email.from"></span>
                    </div>
                    <div>
                        <span class="text-blue-600 font-semibold">From (breakdown):</span>
                    </div>
                    <div class="ml-4">
                        <span class="text-blue-600 font-semibold">Name:</span>
                        <span v-text="email.fromFull.name" v-if="email.fromFull.name"></span>
                        <span v-else class="text-gray-400">none</span>
                    </div>
                    <div class="ml-4">
                        <span class="text-blue-600 font-semibold">Email Address:</span>
                        <span v-text="email.fromFull.emailAddress"></span>
                    </div>
                    <div class="ml-4">
                        <span class="text-blue-600 font-semibold">MailboxHash:</span>
                        <span v-text="email.fromFull.mailboxHash" v-if="email.fromFull.mailboxHash"></span>
                        <span v-else class="text-gray-400">none</span>
                    </div>
                    <div>
                        <span class="text-blue-600 font-semibold">To:</span>
                        <span v-text="email.to"></span>
                    </div>
                    <template v-for="(to,index) in email.toFull">
                        <div>
                            <span class="text-blue-600 font-semibold">To (breakdown {{ index + 1 }}):</span>
                        </div>
                        <div class="ml-4">
                            <span class="text-blue-600 font-semibold">Name:</span>
                            <span v-text="to.name" v-if="to.name"></span>
                            <span v-else class="text-gray-400">none</span>
                        </div>
                        <div class="ml-4">
                            <span class="text-blue-600 font-semibold">Email Address:</span>
                            <span v-text="to.emailAddress"></span>
                        </div>
                        <div class="ml-4">
                            <span class="text-blue-600 font-semibold">MailboxHash:</span>
                            <span v-text="to.mailboxHash" v-if="to.mailboxHash"></span>
                            <span v-else class="text-gray-400">none</span>
                        </div>
                    </template>
                    <div v-if="email.cc">
                        <span class="text-blue-600 font-semibold">CC:</span>
                        <span v-text="email.cc"></span>
                    </div>
                    <template v-for="(to,index) in email.ccFull" v-if="email.ccFull">
                        <div>
                            <span class="text-blue-600 font-semibold">CC (breakdown {{ index + 1 }}):</span>
                        </div>
                        <div class="ml-4">
                            <span class="text-blue-600 font-semibold">Name:</span>
                            <span v-text="to.name" v-if="to.name"></span>
                            <span v-else class="text-gray-400">none</span>
                        </div>
                        <div class="ml-4">
                            <span class="text-blue-600 font-semibold">Email Address:</span>
                            <span v-text="to.emailAddress"></span>
                        </div>
                        <div class="ml-4">
                            <span class="text-blue-600 font-semibold">MailboxHash:</span>
                            <span v-text="to.mailboxHash" v-if="to.mailboxHash"></span>
                            <span v-else class="text-gray-400">none</span>
                        </div>
                    </template>
                    <div v-if="email.bcc">
                        <span class="text-blue-600 font-semibold">BCC:</span>
                        <span v-text="email.bcc"></span>
                    </div>
                    <template v-for="(to,index) in email.bccFull" v-if="email.bccFull">
                        <div>
                            <span class="text-blue-600 font-semibold">BCC (breakdown {{ index + 1 }}):</span>
                        </div>
                        <div class="ml-4">
                            <span class="text-blue-600 font-semibold">Name:</span>
                            <span v-text="to.name" v-if="to.name"></span>
                            <span v-else class="text-gray-400">none</span>
                        </div>
                        <div class="ml-4">
                            <span class="text-blue-600 font-semibold">Email Address:</span>
                            <span v-text="to.emailAddress"></span>
                        </div>
                        <div class="ml-4">
                            <span class="text-blue-600 font-semibold">MailboxHash:</span>
                            <span v-text="to.mailboxHash" v-if="to.mailboxHash"></span>
                            <span v-else class="text-gray-400">none</span>
                        </div>
                    </template>
                    <div>
                        <span class="text-blue-600 font-semibold">Original Recipient:</span>
                        <span v-text="email.originalRecipient"></span>
                    </div>
                    <div>
                        <span class="text-blue-600 font-semibold">Subject:</span>
                        <span v-text="email.subject"></span>
                    </div>
                    <div>
                        <span class="text-blue-600 font-semibold">Mailbox Hash:</span>
                        <span v-text="email.mailboxHash"></span>
                    </div>
                    <div>
                        <span class="text-blue-600 font-semibold">Date:</span>
                        <span v-text="email.date"></span>
                    </div>
                    <div v-if="email.tag">
                        <span class="text-blue-600 font-semibold">Tag:</span>
                        <span v-text="email.tag"></span>
                    </div>
                    <div v-if="email.headers && email.headers.length">
                        <span class="text-blue-600 font-semibold">Headers:</span>
                    </div>
                    <template v-for="(to,index) in email.headers" v-if="email.headers">
                        <div class="ml-4">
                            <span v-text="to.name"></span>
                            <span v-text="to.value" class="ml-2"></span>
                        </div>
                    </template>
                    <div v-if="email.attachments && email.attachments.length">
                        <span class="text-blue-600 font-semibold">Attachments:</span>
                    </div>
                    <template v-for="(to,index) in email.attachments" v-if="email.attachments">
                        <div class="ml-4"><span class="text-blue-600 font-semibold">Attachment {{
                                index + 1
                            }}:</span>
                        </div>
                        <div class="ml-4"><span class="text-blue-600 font-semibold">Name:</span>
                            <span v-text="to.name"></span>
                        </div>
                        <div class="ml-4"><span class="text-blue-600 font-semibold">Content Type:</span>
                            <span v-text="to.contentType"></span>
                        </div>
                        <div class="ml-4"><span class="text-blue-600 font-semibold">Content:</span>
                            <span v-text="to.content"></span>
                        </div>
                    </template>
                </div>
            </ui-tabs>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
            </span>
        </template>
    </ui-modal-full-size>
</template>

<script>

import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiModal from "../../ui/UiModal.vue";
import UiTabs from "../../ui/UiTabs.vue";
import UiModalFullSize from "../../ui/UiModalFullSize.vue";

export default {
    components: {UiModalFullSize, UiTabs, UiModal, UiButtonNew},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        email: {},
        title: {
            type: String,
            default: 'Confirmation'
        },
        button: {
            type: String,
            default: 'Confirmed'
        },
    },
    data() {
        return {
            form: new Form({}, async (form) => {
                await this.handle(form)
                this.close()
            }),
            tabs: [
                {value: 'html', label: 'HTML'},
                {value: 'text', label: 'Plain text'},
                {value: 'data', label: 'Source Data'},
            ],

        }
    },
    methods: {},
    mounted() {
    }
}
</script>
